import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useRingBuilderGranderResultStore = defineStore(
    'ring-builder-grande-result',
    () => {
        const hasSwitchedToGrande = ref(false)

        return { hasSwitchedToGrande }
    }
)
